import * as React from 'react';
import './container.scss';

export class Container extends React.Component<any, any> {
    public outrunnerRef: HTMLDivElement;

    public componentDidMount(): void {
        this.outrunnerRef.onscroll = (event: any) => {
            if (!this.props.disableScrollEvent) {
                (window as any).siteEventSubscribers.contentScroll.next(event.target.scrollTop);
            }
        };

        if (!this.props.disableScrollEvent) {
            (window as any).siteEventSubscribers.contentScroll.next(this.outrunnerRef.scrollTop);
        }
    }

    render() {
        return <div className={`gridContainer animated fadeIn ${this.props.className}`}
                    ref={(ref: any) => { this.outrunnerRef = ref; }}>
            <div className="gridOutrun">
                {this.props.children}
            </div>
        </div>;
    }
}
